/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { registry } from '@/lib/page-designer/registry';

// STATIC_REGISTRY_START

/**
 * Initialize the static component registry.
 * This function is auto-generated by the staticRegistry Vite plugin.
 *
 * DO NOT EDIT THIS FUNCTION MANUALLY - it will be overwritten on next build.
 *
 * Components registered: Content.announcementBanner, Content.articleTile, Content.categoryCarouselOne, Content.categoryCarouselTwo, Content.contentCard, Content.contentOne, Content.contentTwo, Content.customImageCarousel, Content.editorialProductCarousel, Content.embedCode, Content.hero, Content.heroOne, Content.heroTwo, Content.mediaMosaic, Content.pdImage, Content.popularCategory, Content.productRecommendations, Content.productTile, Content.promoCountdownBanner, Content.scoText, Content.scrollingBar, Content.threeCard, Layout.grid, Layout.header, Layout.heroCarousel, Layout.megaMenu, Layout.popularCategories, Layout.productCarousel
 */
export function initializeRegistry(targetRegistry = registry): void {
    targetRegistry.registerImporter(
        'Content.announcementBanner',
        () => import('../../components/announcement-banner/index'),
        { fallback: 'fallback' }
    );
    targetRegistry.registerImporter('Content.articleTile', () => import('../../components/home/article-tile/index'));
    targetRegistry.registerImporter(
        'Content.categoryCarouselOne',
        () => import('../../components/home/category-carousel-one/index')
    );
    targetRegistry.registerImporter(
        'Content.categoryCarouselTwo',
        () => import('../../components/home/category-carousel-two/index'),
        { loader: 'loader' }
    );
    targetRegistry.registerImporter('Content.contentCard', () => import('../../components/content-card/index'));
    targetRegistry.registerImporter('Content.contentOne', () => import('../../components/home/content-one/index'));
    targetRegistry.registerImporter('Content.contentTwo', () => import('../../components/home/content-two/index'));
    targetRegistry.registerImporter(
        'Content.customImageCarousel',
        () => import('../../components/home/custom-image-carousel/index'),
        { loader: 'loader', fallback: 'fallback' }
    );
    targetRegistry.registerImporter(
        'Content.editorialProductCarousel',
        () => import('../../components/home/editorial-product-carousel/index'),
        { loader: 'loader', fallback: 'fallback' }
    );
    targetRegistry.registerImporter('Content.embedCode', () => import('../../components/pd-embed-code/index'));
    targetRegistry.registerImporter('Content.hero', () => import('../../components/hero/index'));
    targetRegistry.registerImporter('Content.heroOne', () => import('../../components/home/hero-one/index'));
    targetRegistry.registerImporter('Content.heroTwo', () => import('../../components/home/hero-two/index'));
    targetRegistry.registerImporter('Content.mediaMosaic', () => import('../../components/home/media-mosaic/index'));
    targetRegistry.registerImporter('Content.pdImage', () => import('../../components/dynamic-image/index'));
    targetRegistry.registerImporter(
        'Content.popularCategory',
        () => import('../../components/home/popular-category/index'),
        { loader: 'loader' }
    );
    targetRegistry.registerImporter(
        'Content.productRecommendations',
        () => import('../../components/product-recommendations/index'),
        { loader: 'loader' }
    );
    targetRegistry.registerImporter('Content.productTile', () => import('../../components/product-tile/index'), {
        loader: 'loader',
    });
    targetRegistry.registerImporter(
        'Content.promoCountdownBanner',
        () => import('../../components/home/promo-countdown-banner/index')
    );
    targetRegistry.registerImporter('Content.scoText', () => import('../../components/home/sco-text/index'));
    targetRegistry.registerImporter('Content.scrollingBar', () => import('../../components/home/scrolling-bar/index'));
    targetRegistry.registerImporter('Content.threeCard', () => import('../../components/home/three-card/index'));
    targetRegistry.registerImporter('Layout.grid', () => import('../../components/grid/index'));
    targetRegistry.registerImporter('Layout.header', () => import('../../components/header/index'));
    targetRegistry.registerImporter('Layout.heroCarousel', () => import('../../components/hero-carousel/index'), {
        fallback: 'fallback',
    });
    targetRegistry.registerImporter('Layout.megaMenu', () => import('../../components/navigation-menu-mega/index'));
    targetRegistry.registerImporter(
        'Layout.popularCategories',
        () => import('../../components/home/popular-categories/index'),
        { loader: 'loader' }
    );
    targetRegistry.registerImporter('Layout.productCarousel', () => import('../../components/product-carousel/index'), {
        loader: 'loader',
        fallback: 'fallback',
    });
}

// STATIC_REGISTRY_END
